import { render, staticRenderFns } from "./BrickSettingsTouchpoint.vue?vue&type=template&id=5e971062&scoped=true&"
import script from "./BrickSettingsTouchpoint.vue?vue&type=script&lang=js&"
export * from "./BrickSettingsTouchpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e971062",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e971062')) {
      api.createRecord('5e971062', component.options)
    } else {
      api.reload('5e971062', component.options)
    }
    module.hot.accept("./BrickSettingsTouchpoint.vue?vue&type=template&id=5e971062&scoped=true&", function () {
      api.rerender('5e971062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/BrickSettings/BrickSettingsTouchpoint.vue"
export default component.exports